import { StoreConstants, ConfigurationChangeState, ConfigurationChangeModel } from '@/types';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<ConfigurationChangeState> = {
  [StoreConstants.ConfigurationChange.Mutations.SetConfigurationChange](
    state, configurationChange: ConfigurationChangeModel) {
    state.configurationChange = configurationChange;
  },
  [StoreConstants.ConfigurationChange.Mutations.SetIsLoading](state, isLoading: boolean) {
    state.isLoading = isLoading;
  },
};
